import http from "./http";

class ContactsService {
    store(data){
        return http.post("/api/contacts/store", data)
    }

    index(token){
        return http.get("/api/contacts",{ headers: { 'Authorization': 'Bearer '+token } })
    }
}

export default new ContactsService()